module.exports = __webpack_public_path__ + "img/service.19e8cca8.png";